import api from './api';

export const getCalendarSubscriptions = () =>
  api.get('/api/v1/calendar-subscriptions').then((r) => r.data.data.subscriptions);

export const createCalendarSubscription = (data) =>
  api.post('/api/v1/calendar-subscriptions', data).then((r) => r.data.data.subscription);

export const updateCalendarSubscription = (id, data) =>
  api.put(`/api/v1/calendar-subscriptions/${id}`, data).then((r) => r.data.data.subscription);

export const deleteCalendarSubscription = (id) =>
  api.delete(`/api/v1/calendar-subscriptions/${id}`).then((r) => r.data);

export const refreshCalendarSubscription = (id) =>
  api.post(`/api/v1/calendar-subscriptions/${id}/refresh`).then((r) => r.data);

export const getExternalCalendarEvents = (from, to) =>
  api.get('/api/v1/calendar-subscriptions/events', { params: { from, to } })
    .then((r) => r.data.data.events);
